import { render, staticRenderFns } from "./NotifySidebar.vue?vue&type=template&id=52341266"
import script from "./NotifySidebar.vue?vue&type=script&lang=js"
export * from "./NotifySidebar.vue?vue&type=script&lang=js"
import style0 from "./NotifySidebar.vue?vue&type=style&index=0&id=52341266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports